'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var CardHeader$2 = require('../../../node_modules/@material-ui/core/esm/CardHeader/CardHeader.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles() {
  return {
    headerPadding: {
      padding: '8px 16px'
    },
    headerAvatar: {
      marginRight: 8
    },
    headerAction: {
      marginRight: -4,
      marginTop: 0
    }
  };
};

var CardHeader = function CardHeader(_ref) {
  var classes = _ref.classes,
      icon = _ref.icon,
      title = _ref.title,
      action = _ref.action,
      props = objectWithoutProperties(_ref, ["classes", "icon", "title", "action"]);

  var titleElement = React__default["default"].isValidElement(title) ? title : React__default["default"].createElement(Typography, {
    variant: 'subtitle1'
  }, title);
  return React__default["default"].createElement(CardHeader$2["default"], _extends["default"]({}, props, {
    classes: {
      root: classes.headerPadding,
      avatar: classes.headerAvatar,
      action: classes.headerAction
    },
    avatar: icon,
    title: titleElement,
    action: action
  }));
};

var CardHeader$1 = withStyles(styles)(CardHeader);

module.exports = CardHeader$1;
